var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('strategio-app-bar'),_vm._v(" "),_c('v-main',{staticStyle:{"height":"100vh","padding-top":"87px"}},[_c('div',{staticStyle:{"max-height":"100%","overflow":"auto"}},[_c('div',{staticClass:"strategio-iframe",attrs:{"id":"reportContainer"}})])])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58f0ea6e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/show-report-bi.vue
// module id = null
// module chunks = 